import React, { useState } from "react";
import { connect } from "react-redux";
import { Chip, Tooltip, TextField, Typography, InputAdornment } from "@material-ui/core";
import { Clear } from "@material-ui/icons";
import dayjs from "dayjs";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import KPTable from "../../../components/KPTable";
import StudentGuidanceUpdateModal from "../StudentGuidanceUpdateModal";
import StudentGuidanceDeleteModal from "../StudentGuidanceDeleteModal";
import HemisCodeConfirmModal from "../../../components/HemisCodeConfirmModal/HemisCodeConfirmModal";

import { updateStudentGuidance, acceptStudentGuidance } from "../../../reducer/studentGuidance/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { STUDENT_GUIDANCE } from "../../../constants/selectOptions";
import { notification } from "../../../reducer/home/action";

function StudentGuidanceTable(props) {
  const [editting, setEditting] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmingAccept, setConfirmingAccept] = useState(null);

  const handleUpdate = (e) => props.setUpdating(e);
  const handleEditYear = (e) => setEditting(e);

  const handleDelete = (event, e) => {
    setDeleting(e.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (value) => setEditting({ ...editting, dashboardYear: value });

  const handleSubmit = (e) => {
    e.preventDefault();
    props.updateStudentGuidance(editting.id, editting);
    setEditting(null);
  };

  const handleClear = () => {
    props.updateStudentGuidance(editting.id, { ...editting, dashboardYear: null });
    setEditting(null);
  };

  const acceptStudentGuidanceItem = async (e) => {
    let result = await props.acceptStudentGuidance(e.id, !e.accepted);
    return result;
  };

  const handleAccept = (e) => {
    // If already accepted (canceling confirmation), no need for modal
    if (e.accepted) {
      acceptStudentGuidanceItem(e).then((success) => {
        if (success) {
          props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
          if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
        }
      });
    } else {
      // If not accepted (confirming), show modal for HemisCode
      setConfirmingAccept(e);
    }
  };

  const handleConfirmAccept = (hemisCode) => {
    const updatedData = {
      ...confirmingAccept,
      hemisCode: hemisCode,
    };

    // First update the student guidance with hemisCode
    props.updateStudentGuidance(confirmingAccept.id, updatedData).then((updateResult) => {
      // Check for ERR_HEMIS_DUPLICATE error
      if (updateResult && updateResult.error === "ERR_HEMIS_DUPLICATE") {
        props.pushNoti({
          type: "warning",
          message: `Mã CTKH "${hemisCode}" đã tồn tại trong hệ thống. Vui lòng kiểm tra lại!`,
        });
        return;
      }

      if (updateResult && updateResult.success) {
        // Then call accept API with boolean value
        props.acceptStudentGuidance(confirmingAccept.id, !confirmingAccept.accepted).then((acceptSuccess) => {
          if (acceptSuccess) {
            props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
            if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
          }
        });
      }
    });

    setConfirmingAccept(null);
  };

  var list = [];
  if (props.type === "all") {
    if (Array.isArray(props.listStudentGuidance)) {
      props.listStudentGuidance.forEach((e) => list.push(e));
    }
  } else {
    if (Array.isArray(props.listStudentGuidanceById)) {
      props.listStudentGuidanceById.forEach((e) => list.push(e));
    }
  }

  const getGuidanceTypeLabel = (value) => {
    const found = STUDENT_GUIDANCE.guidanceType.find((e) => e.value === value);
    return found ? found.title : value || "-";
  };

  const columns = [
    {
      title: <b>Tên đề tài</b>,
      key: "title",
      width: "11%",
      searchable: true,
      sorter: (a, b) => (a.title || "").localeCompare(b.title || ""),
    },
    {
      title: <b>Mã công trình</b>,
      key: "hemisCode",
      width: "9%",
      searchable: true,
      render: (value) =>
        value ? (
          <span style={{ wordBreak: "break-word" }}>{value}</span>
        ) : (
          <span style={{ color: "#aaa" }}>—</span>
        ),
    },
    {
      title: <b>Năm tính giờ</b>,
      key: "year",
      width: "10%",
      searchable: true,
      render: (value) => (value ? `${value} - ${value + 1}` : "-"),
      sorter: (a, b) => (a.year || 0) - (b.year || 0),
    },
    // {
    //   title: <b>Loại đề tài</b>,
    //   key: "type",
    //   width: "15%",
    //   searchable: true,
    //   render: (value) => getGuidanceTypeLabel(value),
    //   type: "include",
    //   filters: STUDENT_GUIDANCE.guidanceType.map((e) => ({ value: e.value, text: e.title })),
    //   onFilter: (value, row) => row.filter((e) => value.includes(e.type)),
    // },
    // {
    //   title: <b>Tên sinh viên</b>,
    //   key: "member",
    //   width: "15%",
    //   searchable: true,
    //   sorter: (a, b) => (a.member || "").localeCompare(b.member || ""),
    // },
    // {
    //   title: <b>Người hướng dẫn</b>,
    //   key: "instructors",
    //   width: "15%",
    //   searchable: true,
    //   sorter: (a, b) => (a.instructors || "").localeCompare(b.instructors || ""),
    // },
    {
      title: <b>Ngày hoàn thành</b>,
      key: "completionDate",
      width: "12%",
      render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : "-"),
      sorter: (a, b) => dayjs(a.completionDate).unix() - dayjs(b.completionDate).unix(),
    },
    {
      title: <b>Số lượng GVHD</b>,
      key: "numberInstructor",
      width: "10%",
      searchable: true,
      sorter: (a, b) => (a.numberInstructor || 0) - (b.numberInstructor || 0),
    },
    {
      title: <b>Hướng dẫn chính</b>,
      key: "studentGuidanceProfile",
      width: "15%",
      render: (value, row) => {
        if (!row?.studentGuidanceProfile || row.studentGuidanceProfile.length === 0) {
          return "-";
        }
        const mainInstructors = row.studentGuidanceProfile
          .filter((member) => member.roleInStudentGuidance === "main")
          .map((member) => {
            if (member.isInternal) {
              return props.profileList.find((p) => p.id === member.profileId)?.name || "";
            } else {
              return member.externalName || "";
            }
          })
          .filter((name) => name !== "")
          .join(", ");
        return mainInstructors || "-";
      },
    },
    // props.role === "sudo-admin" && props.type === "all"
    //   ? {
    //       title: <b>Năm hiển thị</b>,
    //       key: "dashboardYear",
    //       width: "10%",
    //       searchable: true,
    //       render: (value, row) =>
    //         row?.id !== editting?.id ? (
    //           <Tooltip title="Click để chỉnh sửa năm">
    //             <div style={{ cursor: "pointer" }} onClick={() => handleEditYear(row)}>
    //               {value > 0 ? value : "Chưa có năm hiển thị"}
    //             </div>
    //           </Tooltip>
    //         ) : (
    //           <form onSubmit={handleSubmit}>
    //             <TextField
    //               fullWidth
    //               size="small"
    //               type="tel"
    //               variant="outlined"
    //               value={editting?.dashboardYear || ""}
    //               InputProps={{
    //                 endAdornment: (
    //                   <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={handleClear}>
    //                     <Clear style={{ fontSize: 18 }} />
    //                   </InputAdornment>
    //                 ),
    //               }}
    //               onChange={(e) => handleChange(parseInt(e.target.value))}
    //             />
    //           </form>
    //         ),
    //     }
    //   : {
    //       key: "dashboardYear",
    //       width: "0%",
    //       render: () => null,
    //     },
    {
      title: <b>Tình trạng</b>,
      key: "accepted",
      width: "12%",
      render: (value) => (
        <Chip
          size="small"
          color={value ? "primary" : "secondary"}
          label={value ? "Đã được duyệt" : "Chưa được duyệt"}
        />
      ),
      type: "include",
      filters: [
        {
          text: "Đã được duyệt",
          value: true,
        },
        {
          text: "Chưa được duyệt",
          value: false,
        },
      ],
      onFilter: (value, row) => row.filter((e) => value.includes(e.accepted)),
    },
    {
      title: <b>Tác vụ</b>,
      key: "action",
      width: "18%",
      render: (value, row) =>
        row?.id !== editting?.id ? (
          <>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => handleUpdate(row)}
            >
              Chi tiết
            </Typography>
            {row.locked ? (
              <Typography className="table-action-buton" variant="caption" color="textPrimary">
                {`Đã khóa ${
                  (row.locked === "kpi" && "KPI") ||
                  (row.locked === "reward" && "thưởng") ||
                  (row.locked === "timeResearch" && "giờ nghiên cứu")
                }`}
              </Typography>
            ) : (
              <>
                {(props.type !== "all" || props.role === "sudo-admin") && !row.accepted && (
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="secondary"
                    onClick={(event) => handleDelete(event, row)}
                  >
                    Xoá
                  </Typography>
                )}
                {props.role === "sudo-admin" && (
                  <>
                    <Typography
                      className="table-action-buton"
                      variant="caption"
                      color="primary"
                      onClick={(event) => handleAccept(row)}
                    >
                      {row.accepted ? "Hủy xác nhận" : "Xác nhận"}
                    </Typography>
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSubmit}>
              Lưu
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="secondary"
              onClick={() => setEditting(null)}
            >
              Huỷ
            </Typography>
          </>
        ),
    },
  ];

  return (
    <>
      <KPTable
        shadow="none"
        rowsPerPage={10}
        maxHeight="calc(100vh - 288px)"
        columns={columns}
        rows={list.sort((a) => (!a.accepted ? -1 : 1))}
        loading={props.isFetching}
      />
      <StudentGuidanceUpdateModal 
        adminTab={props.adminTab} 
        updating={props.updating} 
        setUpdating={props.setUpdating}
        handleReload={props.handleReload}
      />
      <StudentGuidanceDeleteModal deleting={deleting} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      <HemisCodeConfirmModal
        open={confirmingAccept !== null}
        onClose={() => setConfirmingAccept(null)}
        onConfirm={handleConfirmAccept}
        currentHemisCode={confirmingAccept?.hemisCode || ""}
        title="Xác nhận hướng dẫn sinh viên"
        prefix="SVNCKH"
        dashboardYear={confirmingAccept?.dashboardYear}
        departmentId={confirmingAccept?.departmentId}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  isFetching: select(state, "studentGuidanceReducer", "isFetching"),
  listStudentGuidance: select(state, "studentGuidanceReducer", "listFiltered"),
  listStudentGuidanceById: select(state, "studentGuidanceReducer", "listById"),
});

const mapDispatchToProps = (dispatch) => ({
  acceptStudentGuidance: (id, accept) => dispatch(acceptStudentGuidance(id, accept)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  updateStudentGuidance: (id, payload) => dispatch(updateStudentGuidance(id, payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(StudentGuidanceTable));

